import { useMutation, useQueryClient } from "@tanstack/react-query";
import { taskApi } from "../service";
import { taskKeys } from "../task.keys";
import { scheduleKeys } from "../../../schedule/api/schedule.keys";

/**
 * Delete a task, optionally the whole rest of its series.
 *
 * `forFullSeries` also removes every LATER occurrence, skipping any that is completed or already
 * started — the twin of `useDeleteAppointment`.
 *
 * Rejects with 409 (`TASK_DELETE_FORBIDDEN`) for a completed or already-started task; call sites
 * gate the action on `canDeleteTask` so that answer is not reached by an ordinary click.
 */
export function useDeleteTask() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, forFullSeries }: { id: number; forFullSeries?: boolean }) =>
      taskApi.delete(id, forFullSeries).then((r) => r.data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: taskKeys.lists() });
      // A deleted task must vanish from the calendar too, which is keyed under scheduleKeys.
      queryClient.invalidateQueries({ queryKey: scheduleKeys.all });
    },
  });
}
